import React from 'react';
import {
  Navigate,
  RouteObject
} from 'react-router-dom';

import { SuperAdminLayout } from './SuperAdminLayout';
import { UsersActivity } from './UsersActivity/UsersActivity';
import { StandardAreaInstallationsActivity } from './StandardAreaInstallationsActivity/StandardAreaInstallationsActivity';



export const root: RouteObject = {
  path: 'superAdmin',
  element: (<SuperAdminLayout />),
  children: [
    {
      path: '',
      element: <Navigate to='users' />
    },
    {
      path: 'users',
      element: (<UsersActivity />)
    },
    {
      path: 'standardareainstallations',
      element: (<StandardAreaInstallationsActivity />)
    }
  ]
};
